import { useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Docs() {
  const [spec, setSpec] = useState(null);
  const [error, setError] = useState("");

  // 1) Busca o openapi.json autenticado (rota protegida)
  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    fetch(`${BACKEND_URL}/api/docs/openapi.json`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then(setSpec)
      .catch((e) => setError(`Falha ao carregar a especificação: ${e.message}`));
  }, []);

  // 2) Injeta Swagger UI via CDN e renderiza com o spec carregado
  useEffect(() => {
    if (!spec) return;

    const cssId = "swagger-ui-css";
    if (!document.getElementById(cssId)) {
      const link = document.createElement("link");
      link.id = cssId;
      link.rel = "stylesheet";
      link.href = "https://cdn.jsdelivr.net/npm/swagger-ui-dist@5.17.14/swagger-ui.css";
      document.head.appendChild(link);
    }

    const init = () => {
      // eslint-disable-next-line no-undef
      if (!window.SwaggerUIBundle) return;
      // eslint-disable-next-line no-undef
      window.SwaggerUIBundle({
        spec,
        dom_id: "#swagger-ui",
        deepLinking: true,
        docExpansion: "list",
        defaultModelsExpandDepth: 0,
        persistAuthorization: true,
        // eslint-disable-next-line no-undef
        presets: [window.SwaggerUIBundle.presets.apis],
        layout: "BaseLayout",
      });
    };

    const scriptId = "swagger-ui-script";
    const existing = document.getElementById(scriptId);
    if (existing) {
      init();
    } else {
      const s = document.createElement("script");
      s.id = scriptId;
      s.src = "https://cdn.jsdelivr.net/npm/swagger-ui-dist@5.17.14/swagger-ui-bundle.js";
      s.onload = init;
      document.body.appendChild(s);
    }
  }, [spec]);

  return (
    <div className="fade-in" data-testid="docs-page">
      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
        {error ? (
          <div className="p-8 text-sm text-red-700 bg-red-50 border-b border-red-200">{error}</div>
        ) : null}
        <div id="swagger-ui" className="swagger-container" />
        {!spec && !error ? (
          <div className="p-8 text-sm text-slate-500">Carregando documentação…</div>
        ) : null}
      </div>

      <style>{`
        .swagger-container { padding: 8px 4px; }
        .swagger-ui .topbar { display: none; }
        .swagger-ui .information-container { display: none; }
        .swagger-ui .scheme-container { background: #F8FAFC; box-shadow: none; border-bottom: 1px solid #E2E8F0; padding: 12px 20px; }
        .swagger-ui .opblock-tag { border-bottom: 1px solid #E2E8F0; }
        .swagger-ui .btn.authorize { background: #0F172A; border-color: #0F172A; color: white; }
        .swagger-ui .btn.authorize svg { fill: white; }
        .swagger-ui .btn.execute { background: #0F172A; border-color: #0F172A; }
      `}</style>
    </div>
  );
}
